module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-600.86f6cbd2.eot";